module.exports = __webpack_public_path__ + "img/46.72d78ab0.png";